/**
 * Centralized frontend configuration.
 * All configurable values come from REACT_APP_* environment variables.
 * NEVER hardcode values — add them here and reference via config.section.key.
 */

const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || '/api/v1',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10),
    maxRetries: parseInt(process.env.REACT_APP_API_MAX_RETRIES || '3', 10),
  },
  analytics: {
    enabled: process.env.REACT_APP_ANALYTICS_ENABLED !== 'false',
    debug: process.env.REACT_APP_ANALYTICS_DEBUG === 'true',
    pii_scrubbing: process.env.REACT_APP_ANALYTICS_PII_SCRUBBING !== 'false',
    consent_required: process.env.REACT_APP_CONSENT_REQUIRED !== 'false',
    providers: [
      {
        name: 'console',
        enabled: process.env.REACT_APP_ANALYTICS_DEBUG === 'true',
        config: {},
      },
      {
        name: 'umami',
        enabled: Boolean(process.env.REACT_APP_UMAMI_WEBSITE_ID),
        config: {
          website_id: process.env.REACT_APP_UMAMI_WEBSITE_ID || '',
          base_url: process.env.REACT_APP_UMAMI_BASE_URL || '',
        },
      },
    ],
  },
  socket: {
    url: process.env.REACT_APP_SOCKET_URL || '',
  },
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  },
  pwa: {
    bannerPageViewThreshold: parseInt(process.env.REACT_APP_PWA_BANNER_THRESHOLD || '3', 10),
    bannerDismissDays: parseInt(process.env.REACT_APP_PWA_BANNER_DISMISS_DAYS || '30', 10),
    cacheBudgetMB: parseInt(process.env.REACT_APP_PWA_CACHE_BUDGET_MB || '50', 10),
    offlineReconnectDelay: parseInt(process.env.REACT_APP_PWA_RECONNECT_DELAY || '2000', 10),
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || '',
  },
  chat: {
    queue: {
      storageKeyPrefix: process.env.REACT_APP_CHAT_QUEUE_KEY || 'astro_chat_queue',
      maxRetries: parseInt(process.env.REACT_APP_CHAT_QUEUE_MAX_RETRIES || '3', 10),
      retryDelayMs: parseInt(process.env.REACT_APP_CHAT_QUEUE_RETRY_DELAY || '2000', 10),
      maxRetentionHours: parseInt(process.env.REACT_APP_CHAT_QUEUE_TTL_HOURS || '24', 10),
    },
  },
  broadcast: {
    titleMaxLength: parseInt(process.env.REACT_APP_BROADCAST_TITLE_MAX_LENGTH || '50', 10),
    bodyMaxLength: parseInt(process.env.REACT_APP_BROADCAST_BODY_MAX_LENGTH || '200', 10),
    sendTimeout: parseInt(process.env.REACT_APP_BROADCAST_SEND_TIMEOUT || '30000', 10),
    segments: [
      { key: 'all_users', label: 'All users' },
      { key: 'active_7d', label: 'Active last 7 days' },
      { key: 'all_astrologers', label: 'All astrologers' },
    ],
  },
  call: {
    pip: {
      widthMobile: parseInt(process.env.REACT_APP_PIP_WIDTH_MOBILE || '160', 10),
      heightMobile: parseInt(process.env.REACT_APP_PIP_HEIGHT_MOBILE || '120', 10),
      widthTablet: parseInt(process.env.REACT_APP_PIP_WIDTH_TABLET || '240', 10),
      heightTablet: parseInt(process.env.REACT_APP_PIP_HEIGHT_TABLET || '180', 10),
      widthDesktop: parseInt(process.env.REACT_APP_PIP_WIDTH_DESKTOP || '320', 10),
      heightDesktop: parseInt(process.env.REACT_APP_PIP_HEIGHT_DESKTOP || '240', 10),
      zIndex: parseInt(process.env.REACT_APP_PIP_ZINDEX || '1200', 10),
      snapMargin: parseInt(process.env.REACT_APP_PIP_SNAP_MARGIN || '12', 10),
      dragThreshold: parseInt(process.env.REACT_APP_PIP_DRAG_THRESHOLD || '5', 10),
      splitRatio: parseFloat(process.env.REACT_APP_PIP_SPLIT_RATIO || '0.5'),
    },
  },
  vedic: {
    nominatimUrl: process.env.REACT_APP_NOMINATIM_URL || 'https://nominatim.openstreetmap.org/search',
    nominatimUserAgent: 'JyotishSastra/1.0',
    placeDebounceMs: parseInt(process.env.REACT_APP_PLACE_DEBOUNCE_MS || '500', 10),
    placeMinChars: 3,
    placeLimit: 5,
    defaultTimezone: 'Asia/Kolkata',
    accentColor: '#6c63ff',
  },
};

export default Object.freeze(config);
